import { GalleryImage } from 'common/components';
import { NEW_KITCHEN_CDN_PATH } from '../../new-kitchen-constants';

export const NEW_KITCHEN_SIGN_SECTION_GALLERY_LIST: GalleryImage[] = [
  {
    alt: 'Кухня в магазине с элементами дерева',
    src: `new-kitchen/sign-section/modal/1.jpg/1.jpg`,
    srcSmall: `${NEW_KITCHEN_CDN_PATH}/sign-section/1.jpg/1.jpg`,
    name: 'Кухня в магазине с элементами дерева',
  },
  {
    alt: 'Кухня в магазине в серых тонах',
    src: `new-kitchen/sign-section/modal/2.jpg/2.jpg`,
    srcSmall: `${NEW_KITCHEN_CDN_PATH}/sign-section/2.jpg/2.jpg`,
    name: 'Кухня в магазине в серых тонах',
  },
  {
    alt: 'Ассортимент кухонь в магазине',
    src: `new-kitchen/sign-section/modal/3.jpg/3.jpg`,
    srcSmall: `${NEW_KITCHEN_CDN_PATH}/sign-section/3.jpg/3.jpg`,
    name: 'Ассортимент кухонь в магазине',
  },
];
